/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spell_NumbersInputs */

const en_spell_numbers = /** @type {(inputs: Spell_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spell #1...10`)
};

const fr_spell_numbers = /** @type {(inputs: Spell_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Épeler #1...10`)
};

const de_spell_numbers = /** @type {(inputs: Spell_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zauber #1...10`)
};

const it_spell_numbers = /** @type {(inputs: Spell_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incantesimo n. 1...10`)
};

const ru_spell_numbers = /** @type {(inputs: Spell_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заклинание №1...10`)
};

const es_spell_numbers = /** @type {(inputs: Spell_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hechizo #1...10`)
};

const zh_cn2_spell_numbers = /** @type {(inputs: Spell_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`咒语#1...10`)
};

const ja_spell_numbers = /** @type {(inputs: Spell_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`呪文 #1...10`)
};

const hi_spell_numbers = /** @type {(inputs: Spell_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मंत्र #1...10`)
};

const pt_pt2_spell_numbers = /** @type {(inputs: Spell_NumbersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feitiço nº 1...10`)
};

/**
* | output |
* | --- |
* | "Spell #1...10" |
*
* @param {Spell_NumbersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spell_numbers = /** @type {((inputs?: Spell_NumbersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spell_NumbersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spell_numbers(inputs)
	if (locale === "de") return de_spell_numbers(inputs)
	if (locale === "it") return it_spell_numbers(inputs)
	if (locale === "ru") return ru_spell_numbers(inputs)
	if (locale === "es") return es_spell_numbers(inputs)
	if (locale === "zh-CN") return zh_cn2_spell_numbers(inputs)
	if (locale === "ja") return ja_spell_numbers(inputs)
	if (locale === "hi") return hi_spell_numbers(inputs)
	if (locale === "pt-PT") return pt_pt2_spell_numbers(inputs)
	return en_spell_numbers(inputs)
});